exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".TrackControlsLabel {\n  margin-bottom: 8px;\n  line-height: remy(16);\n  font-size: remy(14);\n  font-weight: bold;\n  text-align: center; }\n", ""]);

// exports
